import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-105" data-mp="20meizq13l45g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-106" data-mp="24ngk6cekrqa2">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-success/25 bg-bg-secondary p-8 sm:p-10" data-id="element-107" data-mp="24l3rb47a3vi8">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success/10" data-id="element-108" data-mp="2jajgifr5vsvt">
            <ShieldCheckIcon size={32} className="text-success" data-id="element-109" data-mp="2obpdwqvro4bo" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-extrabold uppercase leading-tight text-ink sm:text-3xl" data-id="element-110" data-mp="2sbhmv4p2ochk">
            Garantía de Satisfacción de 7 Días
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-111" data-mp="xy89v2xbi8uk">
            Si el producto no cumple con lo prometido, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-flash underline" data-id="element-112" data-mp="3sn9fasxb9r5c">
              manualeslistos@gmail.com
            </a>{' '}
            y te ayudaremos a resolverlo en menos de 24 horas.
          </p>
          <p className="mt-6 text-xs text-muted sm:text-sm" data-id="element-113" data-mp="3dxbpy9nnavek">
            Más de 8.000 profesores ya lo usan. Nuestra tasa de devolución es menor al 0,5%.
          </p>
        </m.div>
      </div>
    </section>;
}